export default __webpack_public_path__ + "static/RecommendationEngine-43f9bd51281af0dedca57b611add0806.png";